/*
 * @Author       : Tom
 * @Date         : 2019-12-21 22:38:28
 * @LastEditors  : Tom
 * @LastEditTime : 2019-12-31 09:58:08
 * @FilePath     : /shop_front_end/src/lib/tool.js
 * @Description  : 公共方法
 */

import _ from 'lodash'

/**
 * 数组深拷贝
 * */ 
export const arrCopy = (arr) => _.cloneDeep(arr)

/**
 * @name 枚举属性的键值对，设置sessionStorage
 * @param { data | Object }
 * */ 
export const setToken = (data) => {
  for (let [key, value] of Object.entries(data)) {
    sessionStorage.setItem(key, value)
  }
}

/**
 * @name 读指定字段sessionStorage内容
 * @param { name | String }
 * */ 
export const getToken = (name) => {
  return sessionStorage.getItem(name)
}

/**
 * @name 清空sessionStorage数据
 * */ 
export const clear = () => {
  return sessionStorage.clear()
}

/**
 * @name 判断登录状态
 * */ 
export const isLogin = () => {
  return !getToken('token')
}

/**
 * @name 取url键值
 * */ 
export const loadPageVar = (Url,sVar) => {
  return decodeURI(Url.replace(new RegExp("^(?:.*[&\\?]" + encodeURI(sVar).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
}

/**
 * @name 小数舍入
 * */ 
export const round = (number, precision) => {
  return Math.round(+number + 'e' + precision) / Math.pow(10, precision);
}